import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "antd";
import React from "react";
import "./style.css";

const PartiesCard = props => {
  const { address, setDetailOpened, deletePartyCard } = props;
  const taxId = address.identifiers?.find(el => el.type === "TAX_ID")?.value;
  const vatNumber = address.identifiers?.find(el => el.type === "VAT_NUMBER")
    ?.value;

  return (
    <div
      key={"dbx-parties-card-root_" + address.id}
      className="dbx-parties-card-root"
    >
      <div className="dbx-parties-card-header">
        <div className="dbx-parties-card-header-icon">
          <FontAwesomeIcon
            icon={["far", address.type === "PERSON" ? "user" : "building"]}
          />
        </div>
        <div className="dbx-parties-card-header-name">
          {address.description}
        </div>
        <div className="dbx-parties-card-header-revenue"></div>
        <div
          className="dbx-parties-card-header-detail"
          style={{ cursor: "pointer" }}
        >
          {
            <FontAwesomeIcon
              icon={["far", "eye"]}
              style={{ marginRight: "16px" }}
              onClick={() => setDetailOpened(address)}
            />
          }
          <Tooltip
            color="white"
            placement="top"
            title={
              <FontAwesomeIcon
                icon={["far", "trash"]}
                style={{ cursor: "pointer" }}
                onClick={() =>
                  deletePartyCard(address._meta.id, address._meta.version)
                }
              />
            }
          >
            <FontAwesomeIcon
              icon={["fal", "ellipsis-v"]}
              style={{ color: "#0090d1", fontSize: "25px" }}
            />
          </Tooltip>
        </div>
      </div>
      <div className="dbx-parties-card-body">
        <div className="dbx-parties-card-body-type">
          {address.type === "STUDIO"
            ? "Libero professionista"
            : address.type === "COMPANY"
              ? "Azienda"
              : "Persona fisica"}
        </div>
        <div className="dbx-parties-card-body-address">
          {`${address?.places[0]?.address?.street.name}, ${address?.places[0]?.address?.street.number} - ${address?.places[0]?.address?.municipality} ${address?.places[0]?.address?.postalCode} - ${address?.places[0]?.address?.province}, ${address?.places[0]?.address?.country}`}{" "}
          <FontAwesomeIcon icon={["far", "map-marker-alt"]} />
        </div>
        <div className="dbx-parties-card-body-fiscal">
          {vatNumber && (
            <div>
              p.iva: <span>{vatNumber}</span>
            </div>
          )}
          {taxId && (
            <div>
              codice fiscale: <span>{taxId}</span>
            </div>
          )}
        </div>
        <div className="dbx-parties-card-body-contacts">
          <div className="dbx-parties-card-body-contacts-emails">
            <div>
              <div>
                <FontAwesomeIcon icon={["fal", "envelope"]} />
              </div>
              <span>{address?.emailAddresses[0]?.value}</span>
            </div>
            {address?.emailAddresses[1]?.value && (
              <div>
                <div>
                  <FontAwesomeIcon icon={["fal", "envelope"]} />
                </div>
                <span>{address?.emailAddresses[1]?.value}</span>
              </div>
            )}
          </div>
        </div>
        <div className="dbx-parties-card-body-deadlines"></div>
      </div>
    </div>
  );
};

export default PartiesCard;
